import React from 'react';
import { Form, Input } from '@agconnections/grow-ui';
import GrowUIFormField from 'components/Forms/GrowUIFormField';

const CityField = () => {
  return (
    <Form.Field label="City">
      <GrowUIFormField control={Input} id="city" name="address.city" />
    </Form.Field>
  );
};

export default CityField;
